export default "__VITE_ASSET__D46pjSjT__"